import Cookies from "js-cookie";
import { API_URL } from "lib/constants";
import { sendHttpRequest } from "lib/fetcher";
import useWsSender from "lib/wsSenderHook";
export function useUpgradeWsService() {
  const { sendWsRequest } = useWsSender();
  async function sendTomlRequest(enabled, id, type) {
    return sendWsRequest("device.remote_ssh", {
      deviceRemoteSsh: {
        enabled,
        id,
        type,
      },
    });
  }
  return { sendTomlRequest };
}

export async function getPassWord(sn, factor, date, orgId) {
  const token = Cookies.get("token");
  try {
    const response = await fetch(
      `${API_URL}/tool/nvr_passwd?sn=${sn}&factor=${factor}&date=${date}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "x-org-id": orgId,
        },
      },
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
}
export function getVersions(service) {
  return sendHttpRequest({
    url: `${API_URL}/service/software_list/group?service=${service}`,
    method: "GET",
  });
}
